var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m156-100-56-56 124-124H120v-80h240v240h-80v-104zm648 0L680-224v104h-80v-240h240v80H736l124 124zM120-600v-80h104L100-804l56-56 124 124v-104h80v240zm480 0v-240h80v104l124-124 56 56-124 124h104v80z"
  })));
};
export default SvgCollapse;